module.exports = __webpack_public_path__ + "static/img/snTitle.c9558465.png";